<template>
  <div>
    <div class="d-flex justify-content-between align-items-center mb-2">
      <h6 class="bold text-secondary-light m-0">
        Professional Information
      </h6>
      <i
        v-if="isEditable"
        class="fa-solid fa-pen-to-square text-primary"
        @click="editProfessionalInfo"
      ></i>
    </div>

    <div class="br-8 table-scroll-wrapper">
      <table
        class="table table-inner-bordered m-0 align-middle text-start bg-blue-light-2 br-8"
      >
        <tbody>
          <tr v-for="(row, rowIndex) in groupedFields" :key="rowIndex">
            <td v-for="(field, colIndex) in row" :key="colIndex">
              <span class="text-primary d-block">{{ field.label }}</span>
              <span :class="field.value ? 'text-secondary bold text-break' : 'text-muted'">
                {{ field.value || "N/A" }}
              </span>
            </td>
            <!-- Fill remaining empty <td>s if fewer than 4 in this row -->
            <!-- <td v-for="n in 4 - row.length" :key="'empty-' + n"></td> -->
          </tr>
        </tbody>
      </table>
    </div>

    <ProfessionalInfoNurseEdit
      :candidateInfo="profile"
      :isShowPopup="EditModal.isShowPopup"
      @modalCallBack="ProfessionalInfoModalCallBack"
      v-if="EditModal.isShowPopup"
      :qualifications="qualifications"
    />
    <Modal
      v-if="splConfirmModal.isShowPopup"
      :modalTitle="splConfirmModal.modalTitle"
      :modalColor="splConfirmModal.modalColor"
      :modalContent="splConfirmModal.modalContent"
      :isShowPopup="splConfirmModal.isShowPopup"
      :buttons="splConfirmModal.buttons"
      :modalCallBack="splModalCallBack"
      :closeOnBackdrop="false"
    />
  </div>
</template>
<script>
import { Role, getScope } from "@/helpers/helper";
import ProfessionalInfoNurseEdit from "./EditForm/ProfessionalInfoNurseEdit";
import { mapActions, mapGetters } from "vuex";
import Modal from "@/components/reusable/Modal";
import moment from "moment";
import isJobSupplier from "@/mixins/isJobSupplier";

export default {
  mixins: [isJobSupplier],
  props: {
    profile: {
      type: Object,
      default: null,
    },
    nurseSpeciality: {
      type: Array,
      default: [],
    },
    specialInterest: {
      type: Array,
      default: [],
    },
    qualifications: {
      type: Array,
      default: () => [],
    },
    isEditable: {
      type: Boolean,
      default: false,
    },
    isModalView: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    ProfessionalInfoNurseEdit,
    Modal,
  },
  data() {
    return {
      currentUserRole: getScope(),
      Role,
      EditModal: {
        isShowPopup: false,
      },
      splConfirmModal: {
        modalColor: "primary",
        modalTitle: "NOTIFICATION",
        modalContent: "Do you need to reset the Special Interest?",
        isShowPopup: false,
        buttons: ["No", "Yes"],
      },
      showMore: false,
    };
  },
  computed: {
    ...mapGetters([
      // "getCandidateSpecialInterest",
      "getLicense",
      "getCandidateNonMedicalQuals",
      "currentUserType",
      "isUKOrganisation",
      "isCandidateRoleFromAccessToken",
      "isEducationalInstituteOrg",
    ]),
    getCandidateSpecialInterest() {
      return (
        (this.profile?.candidate_specialities &&
          this.profile?.candidate_specialities) ||
        []
      );
    },
    mainSpeciality() {
      return this.nurseSpeciality.filter(({ main }) => main) || [];
    },
    otherSpeciality() {
      return this.nurseSpeciality.filter(({ is_current }) => !is_current) || [];
    },
    otherExpertise() {
      return (
        _(this.nurseSpeciality)
          .filter((speciality) => {
            return (
              speciality.main != true &&
              !speciality.other_special_interest &&
              !speciality.special_interest
            );
          })
          .map((val) => {
            return val.speciality
              ? this.isNurse && val?.sub_speciality_id
                ? `${val.speciality?.speciality} - ${val?.sub_speciality?.sub_speciality}`
                : val.speciality?.speciality
              : val?.other_speciality;
          })
          .value()
          .join(", ") || "--"
      );
    },
    highestQualCountry() {
      return (
        (this.highestQualification.length &&
          this.highestQualification
            .map(({ country_name }) => country_name)
            .join()) ||
        "--"
      );
    },
    highestQualYear() {
      return (
        (this.highestQualification.length &&
          this.highestQualification
            .map(({ year_awarded }) => year_awarded)
            .join()) ||
        "--"
      );
    },
    speciality() {
      return (
        (this.mainSpeciality.length &&
          this.mainSpeciality
            .map(({ speciality, sub_speciality }) => {
              this.isNurse && sub_speciality
                ? `${speciality?.speciality} - ${sub_speciality?.sub_speciality}`
                : speciality
            })
            .join()) ||
        this.profile?.speciality?.speciality ||
        "--"
      );
    },
    expertise() {
      return (
        (this.otherSpeciality.length &&
          this.otherSpeciality
            .map(({ speciality: { speciality } }) => speciality)
            .join()) ||
        "--"
      );
    },
    yearsSpeciality() {
      return (
        (this.mainSpeciality.length &&
          this.mainSpeciality
            .map(({ experience_in_years }) => experience_in_years)
            .join()) ||
        "--"
      );
    },
    specialInterestName() {
      return (
        (this.specialInterest.length &&
          this.specialInterest
            .map(({ special_interest, other_special_interest }) =>
              special_interest
                ? special_interest?.special_interest
                : other_special_interest
            )
            .join()) ||
        "--"
      );
    },
    firstQualification() {
      return (
        (this.profile?.qualifications &&
          this.profile?.qualifications.filter(
            ({ main }) =>
              (main && this.profile.qualifications.length === 1) ||
              (!main && this.profile.qualifications.length > 1)
          )) ||
        []
      );
    },
    firstQualificationName() {
      return (
        (this.firstQualification.length &&
          this.firstQualification
            .map(
              ({
                qualification_name,
                month_awarded,
                year_awarded,
                country_name,
              }) =>
                `${qualification_name}-${country_name}-${this.formatDate(
                  month_awarded,
                  year_awarded
                )}`
            )
            .join()) ||
        "--"
      );
    },
    highestQualification() {
      return (
        (this.profile?.qualifications &&
          this.profile.qualifications.length > 1 &&
          this.profile?.qualifications.filter(({ main }) => main)) ||
        (this.profile.qualifications.length === 1 &&
          this.profile?.qualifications) ||
        []
      );
    },
    highestQualificationName() {
      if (
        this.profile?.qualifications &&
        this.profile?.highest_qualification_name &&
        this.profile?.highest_qualification_name == "Other - not listed"
      ) {
        return _(this.profile?.qualifications)
          .filter((qualification) => {
            return (
              qualification?.main &&
              qualification?.qualification_name ==
                this.profile?.highest_qualification_name
            );
          })
          .map((qualification) => {
            return qualification?.other_qualification_name
              ? "Other - " + qualification?.other_qualification_name
              : null;
          })
          .value()
          .toString();
      } else {
        return (
          this.highestQualification.length &&
          this.highestQualification
            .map(
              ({
                qualification_name,
                description,
                qualification: { allow_subject_input },
              }) =>
                `${qualification_name}${
                  allow_subject_input && description
                    ? "(" + description + ")"
                    : ""
                }`
            )
            .join()
        );
      }
    },
    nonMedicalQualifications() {
      return (
        this.getCandidateNonMedicalQuals
          .map(({ non_medical_qual }) => non_medical_qual?.name)
          .join() || "--"
      );
    },
    candidateLevel() {
      return this.profile?.candidate_level?.candidate_level
        ? `${this.profile?.candidate_level?.candidate_level}${
            this.profile?.candidate_level?.description !==
            this.profile?.candidate_level?.candidate_level
              ? " - " + this.profile?.candidate_level?.description
              : ""
          }`
        : "--";
    },
    pqrlevel() {
      const pqr =
        this.profile.pqr_levels.filter(({ potential }) => !potential) || [];
      if (pqr.length) {
        if (pqr[0]?.working_candidate_level) {
          const level = pqr[0]?.working_candidate_level;
          const country_code =
            pqr[0]?.pqr_detail?.pqr_header?.country?.country_code;
          return country_code ? `${level}(${country_code})` : level;
        }
      }
      return "--";
    },
    isNurse() {
      return this.profile?.candidate_type_id
        ? this.profile?.candidate_type_id === 2
        : false;
    },
    nurseType() {
      return this.profile?.nurse_registration_type
        ? this.profile?.nurse_registration_type
            .filter((v) => v != "any_higherqualification_related_to_practice")
            .map((v) => _.startCase(v))
            .join(", ") || "--"
        : "--";
    },
    licenseLevel() {
      return `${this.profile?.license_level_name || "--"} / ${
        this.profile?.licensing_country_name || "--"
      }`;
    },
    nhsBand() {
      return this.profile.band?.band_name || null;
    },
    levelName() {
      return this.profile?.candidate_level_name || "--";
    },
    isStudent() {
      return this.profile.is_student || false;
    },
    studentQualification() {
      return this.profile?.qualifications?.[0] || {};
    },
    isSponsored() {
      return this.profile?.is_sponsored;
    },
    sponsoredDetails() {
      return this.profile?.sponsored;
    },
    studentCourse() {
      return this.profile?.student_course;
    },
    trainingCourse() {
      return this.profile?.student_course?.training_course;
    },
    groupedFields() {
      const chunkSize = 4;
      const chunks = [];
      for (let i = 0; i < this.profileFields.length; i += chunkSize) {
        chunks.push(this.profileFields.slice(i, i + chunkSize));
      }
      return chunks;
    },
    profileFields() {
      const data = [];

      if (!this.isStudent) {
        data.push(
          { label: "Main Speciality", value: this.speciality },
          { label: "Years in Speciality", value: this.yearsSpeciality },
          { label: "Other Expertise", value: this.otherExpertise },
          { label: "Highest Med Qual", value: this.highestQualificationName },
          { label: "Country Obtained", value: this.highestQualCountry },
          { label: "Year Obtained", value: this.highestQualYear },
          { label: "Current License / Location", value: this.licenseLevel },
          { label: "Working As", value: this.levelName },
          { label: "Current Job Title", value: this.profile.current_job },
          { label: "Current NHS Band", value: this.nhsBand || "--" },

          !this.isCandidateRoleFromAccessToken && {
            label: "Suitable For",
            value: this.pqrlevel,
          }
        );
      }

      if (this.isStudent && !this.studentCourse) {
        data.push(
          {
            label: "Study Location",
            value: this.studentQualification?.country_name || "--",
          },
          {
            label: "Training Area",
            value: this.studentQualification.speciality_name || "--",
          },
          {
            label: "Course level",
            value: this.studentQualification?.qualification_name || "--",
          },
          {
            label: "Course Start Date",
            value:
              this.formatDateMonthYear(
                this.studentQualification?.course_start_date
              ) || "--",
          },
          {
            label: "Course End Date",
            value:
              this.formatDateMonthYear(
                this.studentQualification?.predicted_completion_date
              ) || "--",
          }
        );

        data.push(
          {
            label: "Is your course",
            value: this.studentQualification?.full_part_time || "--",
          },
          {
            label: "Course Mode",
            value:
              this.studentQualification?.distance_learning === true
                ? "Yes"
                : this.studentQualification?.distance_learning === false
                ? "No"
                : "Classroom based",
          },
          {
            label: "Sponsored student",
            value: this.isSponsored ? "Yes" : "No",
          },
          this.isSponsored && {
            label: "Sponsorship Duration",
            value:
              this.formatDateMonthYear(this.sponsoredDetails?.start_date) +
              " - " +
              (this.sponsoredDetails?.end_date
                ? this.formatDateMonthYear(this.sponsoredDetails.end_date)
                : "?"),
          }
        );
      }

      if (this.isStudent && this.studentCourse) {
        data.push(
          {
            label: "Course Title",
            value: this.trainingCourse?.course_title || "--",
          },
          {
            label: "Is your course",
            value: this.studentCourse?.full_part_time || "--",
          },
          {
            label: "Start Date",
            value:
              formatDateMonthYear(this.studentCourse?.course_start_date) ||
              "--",
          },
          {
            label: "Completion Date",
            value: formatMonthYear(this.studentCourse?.course_end_date) || "--",
          },
          {
            label: "Course Mode",
            value:
              this.studentCourse &&
              this.studentCourse.distance_learning === true
                ? "Yes"
                : this.studentCourse &&
                  this.studentCourse.distance_learning === false
                ? "No"
                : "Classroom based",
          },
          {
            label: "Sponsored student",
            value: this.isSponsored ? `Yes` : "No",
          },
          {
            label: "Sponsorship Start Date",
            value:
              formatDateMonthYear(this.sponsoredDetails?.start_date) || "--",
          },
          {
            label: "Sponsorship Expiry Date",
            value: formatDateMonthYear(this.sponsoredDetails?.end_date) || "--",
          }
        );
      }

      return data.filter(Boolean);
    },
  },
  methods: {
    ...mapActions([
      "updateCandidate",
      "fetchQualification",
      "deleteSplInterestWithoutToast",
      "fetchspecialInterest",
      "showToast",
      "fetchPQRLevels",
    ]),
    editProfessionalInfo() {
      this.EditModal.isShowPopup = true;
    },
    ProfessionalInfoModalCallBack(action, data, isSpecialityChanged) {
      this.EditModal.isShowPopup = false;
      if (action === true && data != null) {
        const { customer_uid } = this.profile;
        let appentAction = this.updateCandidate({ data, customer_uid });
        Promise.all([appentAction]).then(async (res) => {
          await this.fetchPQRLevels();
          if (isSpecialityChanged?.length) {
            this.fetchQualification();
            if (
              this.getCandidateSpecialInterest?.length &&
              isSpecialityChanged.some((val) => val == "speciality_id")
            ) {
              this.splConfirmModal.isShowPopup = true;
            }
          }
        });
      }
    },
    splModalCallBack(action) {
      this.splConfirmModal.isShowPopup = false;
      if (action == "Yes") {
        let appendAction = [];
        this.getCandidateSpecialInterest.forEach((val) => {
          if (val.special_interest_id)
            appendAction = this.deleteSplInterestWithoutToast(
              val.candidate_speciality_id
            );
        });
        Promise.all([appendAction]).then((res) => {
          this.fetchspecialInterest();
          this.showToast({
            class: "bg-success text-white",
            message: "Special Interest reset successful",
          });
        });
        this.$parent.goToSplInterestSection();
      }
    },
    formatDate(month_awarded, year_awarded) {
      if (month_awarded)
        return `${moment.monthsShort()[month_awarded - 1]} - ${year_awarded}`;
      return year_awarded || "";
    },
    ShowMoreLess() {
      this.showMore = !this.showMore;
    },
    formatDateMonthYear(date) {
      return date ? moment(date).format("DD MMM YYYY") : "--";
    },
    formatMonthYear(date) {
      return date ? moment(date).format("YYYY MMM") : "--";
    },
  },
};
</script>
